// extracted by mini-css-extract-plugin
export default {"content":"PhoneStep_content__Z5Aet","title":"PhoneStep_title__Eykqd","description":"PhoneStep_description__k2A3m"};